import { useEffect } from 'react';
const SSOT = 'ssot';
/**
 * Hook that allows component references to be shared with a component API through the Single Source of Truth.
 *
 * @param options - Hook options.
 * @param options.name - Name under which the reference will be available in the shared references object;
 * @param options.props - The entire properties object of the component, containing the SSOT;
 * @param options.ref - The reference being shared.
 */
function useSharedRef(options) {
    const { name, props, ref } = options;
    const ssot = Object.prototype.hasOwnProperty.call(props, SSOT)
        // @ts-ignore: Ignoring because the SSOT property is not explicility declared in the props object
        ? props[SSOT]
        : null;
    useEffect(() => {
        if (!ssot || !ref.current) {
            return;
        }
        ssot.setRef(name, ref.current);
        return () => {
            ssot.removeRef(name);
        };
    }, [name, ref]);
}
export { useSharedRef, };
//# sourceMappingURL=use-shared-ref.js.map